/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { Modal, Nav, Tab, Tabs } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../nodes/Logic/Inputs/Input";
import JsonCollapse from "../JsonCollapse";
import TokenEditor from "../TokenEditor";
import UsedInLink from "../UsedInLink";
import ContactsAndGroups from "./ContactsAndGroups";
import {
  addNewMessageConfig,
  addNewMessageTemplate,
  selectInputArguments,
  selectMessageConfigs,
  selectMessageTemplate,
  selectProjectMessageConfigUUID,
  setMessageTemplate,
} from "../../../store/slices/projectSlice";
import SMSCounter from "../SMSCounter";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { useGetCommsSettingsDataQuery } from "../../../store/slices/settingsSlice";

export default function MessageTemplate() {
  const navigate = useNavigate();
  const params = useParams();
  const projectMessageConfigUUID = useSelector(selectProjectMessageConfigUUID);
  const inputArguments = useSelector(selectInputArguments);
  const messageConfigs = useSelector(selectMessageConfigs);
  const message = useSelector(
    selectMessageTemplate(params.messageTemplateUUID)
  );
  const dispatch = useDispatch();
  const setMessage = (fn) => dispatch(setMessageTemplate(fn(message)));

  const location = useLocation();
  const handleClose = () => {
    if (message?.Label) {
      navigate(
        location.state?.nextPage || `/library/logic/builder/${params.projectID}`
      );
    } else {
      toast.error("Label missing!");
    }
  };

  // set message when renders
  useEffect(() => {
    if (params.messageTemplateUUID) {
      if (params.messageTemplateUUID === "create_new") {
        const newMessageUUID = uuidv4();
        dispatch(addNewMessageTemplate({ UUID: newMessageUUID }));
        navigate(
          `/library/logic/builder/${params.projectID}/message-template/${newMessageUUID}`,
          {
            replace: true,
          }
        );
      }
    }
  }, [params.messageTemplateUUID]);

  const [editorType, setEditorType] = useState("");
  const { data: commsSettings } = useGetCommsSettingsDataQuery();

  return (
    <Modal
      size="xl"
      show={params.messageTemplateUUID && message}
      onHide={handleClose}
      scrollable
      className="message-template-modal"
      backdropClassName="message-template-modal-backdrop"
      enforceFocus={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="icon fa fa-edit" />
          {params.messageTemplateUUID === "create_new" ? "Create " : "Edit "}
          message template
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div>
            <div className="mb-3">
              <label className="form-label">Messsage label</label>
              <input
                className="form-control"
                title="Message label"
                placeholder="Message label"
                type="text"
                value={message?.Label ?? ""}
                onChange={(e) => {
                  setMessage((prev) => ({ ...prev, Label: e.target.value }));
                }}
              />
              {!message?.Label && (
                <span className="text-danger">Need a label!</span>
              )}
            </div>
            <Tabs
              id="controlled-message-template-tab"
              className="mb-3"
              mountOnEnter
              activeKey={params.messageTemplateTab || "message"}
              onSelect={(key) => {
                if (key === "message") {
                  navigate(
                    `/library/logic/builder/${params.projectID}/message-template/${message.UUID}/`
                  );
                } else if (key === "send-list") {
                  navigate(
                    `/library/logic/builder/${params.projectID}/message-template/${message.UUID}/send-list`
                  );
                }
              }}
            >
              <Tab eventKey="message" title="Message">
                <div className="my-2">
                  <Input
                    inputType="checkbox"
                    label="Load message content from variable"
                    value={[message?.FromVariable]}
                    onChange={([v]) => {
                      setMessage((prev) => ({
                        ...prev,
                        InputArgumentUUID: null,
                        FromVariable: v,
                      }));
                    }}
                    options={[
                      { value: true, label: "yes" },
                      { value: false, label: "no" },
                    ]}
                  />
                </div>
                {message?.FromVariable ? (
                  <div className="my-2">
                    Select variable
                    <Input
                      inputType="select"
                      value={[message?.InputArgumentUUID]}
                      onChange={([v]) => {
                        setMessage((prev) => ({
                          ...prev,
                          InputArgumentUUID: v,
                        }));
                      }}
                      options={inputArguments
                        .filter((arg) => arg.Format === "editor")
                        .map((arg) => ({
                          value: arg.UUID,
                          label: arg.Label,
                        }))}
                    />
                  </div>
                ) : null}
                <div>
                  {message && (
                    <div>
                      <Nav
                        variant="tabs"
                        activeKey={editorType}
                        onSelect={(k) => setEditorType(k)}
                      >
                        <Nav.Item>
                          <Nav.Link eventKey="" tabIndex={-1}>
                            Editor
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="sms" tabIndex={-1}>
                            SMS Preview
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="email" tabIndex={-1}>
                            Email Preview
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>

                      <div
                        className={
                          editorType === ""
                            ? "large-editor"
                            : "bg-white p-3 border rounded-3"
                        }
                        style={{ minHeight: 300 }}
                      >
                        <div
                          className={
                            editorType === "sms"
                              ? "bg-info bg-opacity-50 rounded-3 p-3 d-inline-block"
                              : ""
                          }
                          style={{
                            width: editorType === "sms" ? 300 : "100%",
                          }}
                        >
                          <TokenEditor
                            preview={editorType}
                            showButtons
                            initialText={message?.Text}
                            rawEditorState={message?.EditorState}
                            inputArguments={inputArguments}
                            onChange={({
                              rawEditorState,
                              HTMLtext,
                              tokens,
                              plainText,
                              shortlinks,
                            }) =>
                              setMessage((prev) => ({
                                ...prev,
                                EditorState: rawEditorState,
                                Text: HTMLtext,
                                Tokens: tokens,
                                PlainText: plainText,
                                Shortlinks: shortlinks,
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="my-3">
                    <SMSCounter text={message?.PlainText?.trim() ?? ""} />
                    {message?.Tokens?.length > 0 && (
                      <div className="text-danger">
                        SMS character count will not be accurate when you use
                        tokens.
                      </div>
                    )}
                    {message?.Shortlinks?.startingWith?.length > 0 && (
                      <div className="text-danger">
                        SMS character count will not be accurate when you use
                        shortlinks.
                      </div>
                    )}
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Message config</label>
                  {message?.MessageConfigUUID && (
                    <Link
                      className="float-end me-2"
                      to={`/library/logic/builder/${params.projectID}/message-config/${message?.MessageConfigUUID}`}
                      state={{ nextPage: location.pathname }}
                    >
                      <FontAwesomeIcon icon={faPenToSquare} />
                    </Link>
                  )}
                  <Input
                    inputType="select"
                    options={[
                      {
                        value: "",
                        label: `[use project default] - ${
                          messageConfigs.find(
                            (mc) => mc.UUID === projectMessageConfigUUID
                          )?.Label
                        }`,
                      },
                      ...messageConfigs.map((cs) => ({
                        value: cs?.UUID,
                        label: cs?.Label,
                      })),
                    ]}
                    isValidNewOption={(v) => v}
                    onCreateOption={(value) => {
                      const newUUID = uuidv4();
                      dispatch(
                        addNewMessageConfig({
                          UUID: newUUID,
                          Label: value,
                          commsSettings,
                        })
                      );
                      setMessage((prev) => ({
                        ...prev,
                        MessageConfigUUID: newUUID,
                      }));
                      navigate(
                        `/library/logic/builder/${params.projectID}/message-config/${newUUID}`,
                        {
                          state: { nextPage: location.pathname },
                        }
                      );
                    }}
                    value={[
                      message?.MessageConfigUUID || "",
                      //   "Default will be used. Select a message config or start typing to create a new one.",
                    ]}
                    onChange={(values) => {
                      setMessage((prev) => ({
                        ...prev,
                        MessageConfigUUID: values[0],
                      }));
                    }}
                  />
                </div>
                <UsedInLink arg={message} />
                <JsonCollapse json={message} />
              </Tab>
              <Tab eventKey="send-list" title="Contacts and groups">
                <ContactsAndGroups
                  uuid={message?.UUID}
                  uuidType="template"
                  onSave={() => {
                    setMessage((prev) => ({ ...prev, ContactSetUUID: "yes" }));
                  }}
                />
              </Tab>
            </Tabs>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
